import React, { memo } from 'react'
import PropTypes from 'prop-types'
import SignIn from '../SignIn'
import SignedIn from '../SignedIn'
import useSSO from '../../hooks/useSSO'
import useLogin from '../../hooks/useLogin'
import useLogout from '../../hooks/useLogout'

function Account({ isMobile }) {
  const { isEnabled, isSignedIn, handleSignOut, ...props } = useSSO()
  const { onLoginClick } = useLogin({
    session: typeof window === 'object' && window.location.href,
  })
  const { onLogoutClick } = useLogout()

  const Component = isSignedIn ? SignedIn : SignIn

  return isEnabled ? (
    <Component
      {...props}
      isMobile={isMobile}
      onLoginClicked={onLoginClick}
      onLogoutClicked={() => handleSignOut(onLogoutClick)}
    />
  ) : null
}

Account.propTypes = {
  isMobile: PropTypes.bool,
}

Account.displayName = 'Account'

export default memo(Account)
